import React from "react";
import { Chart } from "react-google-charts";
import numbro from "numbro";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

const PieCharts = ({ data = [], title }) => {
  const chartData = data.sort((a, b) => {
    let num1 = numbro.unformat(a[1]);
    let num2 = numbro.unformat(b[1]);
    return num2 - num1;
  });
  const options = {
    sliceVisibilityThreshold: 0,
    backgroundColor: { fill: "transparent" },
    pieSliceBorderColor: "transparent",
    colors: [
      "#ff664e",
      "#1794ca",
      "#21e981",
      "#df30e5",
      "#1cdac4",
      "#7d4eff",
      "#ffbe4e",
      "#ca5317"
    ],
    tooltip: {
      trigger: "selection",
      textStyle: {
        fontSize: 14,
        bold: true,
        color: "#8791A0"
      }
    },
    chartArea: { left: 0, top: 20, width: "80%", height: "75%" },
    legend: {
      textStyle: {
        color: "#8791A0",
        fontSize: 16,
        bold: true
      },
      pagingTextStyle: {
        color: "#8fc447"
      },
      scrollArrows: {
        activeColor: "#8fc447"
      }
    }
  };
  return (
    <div data-testid={"pie-chart"}>
      <h5 className={"pie-chart__title"}>{title}</h5>
      {chartData.length > 1 ? (
        <Chart
          loader={<LoadingAnimation text={"Loading"} />}
          chartType="PieChart"
          data={chartData}
          options={options}
          width="330px"
        />
      ) : (
        <p className="error">No data available</p>
      )}
    </div>
  );
};

export default PieCharts;
